import LayoutCentered from '@/layout/LayoutCentered';
import ChatbotStats from '@/components/pages/chatbot/ChatbotStats';
import ConversationList from '@/components/pages/chatbot/ConversationList';
import ConversationDetail from '@/components/pages/chatbot/ConversationDetail';

export default [
  {
    path: '/chatbot-stats',
    name: 'ChatbotStats',
    component: LayoutCentered,
    meta: { auth: true, requirePermission: 'chatbot' },
    children: [
      {
        path: '',
        name: 'ChatbotStatsHome',
        component: ChatbotStats,
      },
    ],
  },

  {
    path: '/chatbot-conversations',
    name: 'ChatbotConversations',
    component: LayoutCentered,
    meta: { auth: true, requirePermission: 'chatbot' },
    children: [
      {
        path: '',
        name: 'ChatbotConversationList',
        component: ConversationList,
      },
      {
        path: ':id',
        name: 'ChatbotConversationDetail',
        component: ConversationDetail,
      },
    ],
  },
];
